import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '8px',
  },
  button: {
    padding: '8px',
    background: theme.background.b2,
    borderRadius: theme.borderRadius.md,
    ...dFlex('space-between', 'center'),

    '&:hover': {
      background: theme.secondary.s5,
    },

    '&:disabled': {
      opacity: 0.4,
      pointerEvents: 'none',
    },
  },
  row: {
    ...dFlex('unset', 'center'),
    gap: '16px',

    img: {
      borderRadius: '8px',
    },
  },
  badge: {
    borderRadius: theme.borderRadius.sm,
    padding: '8px 16px',
  },
  qrCode: {
    background: theme.accent.a9,
  },
  installed: {
    background: theme.accent.a5,
  },
  notInstalled: {
    background: theme.accent.a4,
  },
  icon: {
    borderRadius: theme.borderRadius.md,
  },
}));

export default useStyles;
